module.exports = __webpack_public_path__ + "img/icon-view-grid.2fb7621a.svg";